"use client";
import { SectionTemplate } from "components/individuals/blocks";
import { Text, Flex, Box, Heading } from "@chakra-ui/react";
import { EnterpriseCarousel } from "./enterprise-carousel";
import { RichText } from "@graphcms/rich-text-react-renderer";
import { richTextRenderers } from "components/individuals/mdx-components";
import { RichTextContent } from "@graphcms/rich-text-types";

export interface RiskInfoSectionProps {
  title: string;
  subtitle: string;
  content?: {
    raw: RichTextContent;
  };
  additionalText: string;
  bg: string;
  textColor: string;
  titleColor: string;
  highlightsSection: {
    highlight: {
      description: string;
    }[];
  };
}

export const RiskInfoSection = ({
  title,
  subtitle,
  content,
  additionalText,
  bg,
  textColor,
  titleColor,
  highlightsSection,
}: RiskInfoSectionProps) => {
  return (
    <SectionTemplate
      bg={bg}
      pb={{
        base: 0,
      }}
    >
      <Heading
        as={"h2"}
        color={titleColor}
        fontSize={{
          base: 26,
          md: 34,
          lg: 38,
          xl: 45,
        }}
        fontWeight={"bold"}
        lineHeight={1.2}
        mb={{
          base: 6,
          lg: 8,
        }}
        w={{
          base: "full",
          lg: "95%",
        }}
      >
        {title}
      </Heading>
      <Flex
        alignItems="center"
        color={textColor}
        flexDir={{
          base: "column",
          lg: "row",
        }}
        justifyContent={{
          lg: "space-between",
        }}
      >
        <Box
          fontSize={{
            base: 14,
            md: 16,
            lg: 17,
            xl: 18,
          }}
          mr={{
            lg: 10,
            xl: 16,
          }}
        >
          <Text
            mb={{
              base: 4,
              lg: 6,
            }}
          >
            {subtitle}
          </Text>
          <Box
            mb={{
              base: 4,
              lg: 6,
            }}
          >
            <RichText
              content={content?.raw as RichTextContent}
              renderers={richTextRenderers}
            />
          </Box>
          <Text>{additionalText}</Text>
        </Box>
        <EnterpriseCarousel slideContent={highlightsSection.highlight} />
      </Flex>
    </SectionTemplate>
  );
};
